var _style, _defs, _path, _path2, _line, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconKeypadUnlocked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000128453416692118911090000004410463781443737749_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17.3 17.7",
    style: {
      enableBackground: "new 0 0 17.3 17.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000087381965718622346750000000820960178872897201_);}\r\n\t.st1{fill:none;stroke:#667085;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st2{fill:#667085;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 17.3,
    height: 17.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000093899123180912925670000015206712686691510925_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000093899123180912925670000015206712686691510925_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6,7.1h8.5c1.1,0,2,0.9,2,2v5.8c0,1.1-0.9,2-2,2H6c-1.1,0-2-0.9-2-2V9.1C4,8,4.9,7.1,6,7.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.9,4.5c0-1.9,1.2-3.6,3-3.6c3.4,0,3.4,3.4,3.4,3.4v2.8"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 10.2,
    y1: 11.5,
    x2: 10.2,
    y2: 13.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10.2,10.5c0.6,0,1.1,0.5,1.1,1.1s-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1S9.6,10.5,10.2,10.5"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKeypadUnlocked);
export default __webpack_public_path__ + "static/media/icon_keypad_unlocked.9195cb579b4659f720eb3267f22833ce.svg";
export { ForwardRef as ReactComponent };